import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading, Text } from "@miro-site/core";
import React from "react";
import styled from "styled-components";
var FaqItem = styled(Box).attrs({
    $mb: 24
}).withConfig({
    componentId: "sc-8af6850f-0"
})(_templateObject());
var Question = styled(Text).attrs({
    $styles: {
        fontWeight: 700,
        fontSize: 18,
        lineHeight: 26,
        marginBottom: 8
    }
})({});
var Answer = styled(Text).attrs({
    $styles: {
        fontSize: 18,
        lineHeight: 26
    }
})({});
var FaqItems = function(param) {
    var title = param.title, items = param.items;
    return /*#__PURE__*/ _jsxs(Box, {
        $mt: [
            40,
            60,
            60,
            60
        ],
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                $variant: "h3",
                $mb: 24,
                children: title
            }),
            items.map(function(item) {
                return /*#__PURE__*/ _jsxs(FaqItem, {
                    children: [
                        /*#__PURE__*/ _jsx(Question, {
                            as: "h3",
                            children: item.question
                        }),
                        /*#__PURE__*/ _jsx(Answer, {
                            children: item.answer
                        })
                    ]
                }, item.question);
            })
        ]
    });
};
export default FaqItems;
